import * as angular from 'angular';

import { ComponentDefinition, Identifier, ImportResult } from '../../../models';
import { IidentifierService, ILoggerService } from '../../../services';
import { guidEmpty } from '../../../common/constants';

class IdentifiersImportController implements angular.IComponentController {
    fileList: FileList;
    importResult: ImportResult;
    isLoading: boolean;

    readonly groupGuid: string;
    readonly onRefresh: (data: { updated: Identifier[] }) => void;

    static $inject = [
        'identifierService',
        'loggerService'
    ];

    constructor(
        private _identifierService: IidentifierService,
        private _loggerService: ILoggerService
    ) {
    }
    
    upload(files: FileList) {
        this.fileList = files;
        if (files && files.length) {
            this.isLoading = true;
            this._identifierService
                .upload(files[0], this.groupGuid || guidEmpty)
                .then(data => {
                    this.importResult = {
                        result: data.result,
                        createdCount: data.created.length,
                        updatedCount: data.updated.length,
                        failedCount: data.notUpdated.length
                    };
                    if (this.onRefresh) {
                        this.onRefresh({ updated: data.created.concat(data.updated) });
                    }
                })
                .catch(reason => {
                    this._loggerService.logError(reason.data.Message);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}

export const wtIdentifiersImport: ComponentDefinition = {
    componentId: 'wtIdentifiersImport',
    controller: IdentifiersImportController,
    template: require('./identifiersImport.component.html'),
    controllerAs: 'vm',
    bindings: {
        onRefresh: '&?',
        groupGuid: '<?'
    }
};